import { getHistoryUrlParams, unsetHsSelectedAction } from '@/store/gamestate/gamestate'
import omitBy from 'lodash/omitBy'
import isEmpty from 'lodash/isEmpty'
// const aplha = 'tra/alpha'
import { sanitizeQuery } from '@/store/router/router'
import { getTrainerClearQuery } from '@/helpers/trainer_presets'

const getInitialState = () => ({
  configure: true,
  active_namespace: 'tra/alpha',
  locked_namespaces: [],
})
const state = getInitialState()

const getters = {
  active_namespace: (state, getters) =>
    getters.globals_mobile ? 'tra/alpha' : state.active_namespace,
  active_instance: (state, getters) =>
    getters.globals_mobile ? 'alpha' : state.active_namespace.replace('tra/', ''),
  locked_instances: (state, getters) =>
    getters.globals_mobile ? 'alpha' : state.locked_namespaces.map(nn => nn.replace('tra/', '')),
  active_namespace_idx: (state, getters) =>
    getters.hands_namespaces.findIndex(nn => nn === getters.active_namespace),
  locked_namespaces: state => state.locked_namespaces,
  active_namespaces: (state, getters, rootState, rootGetters) => {
    const numOfTables = Number(rootGetters[`tra/alpha/fh_trainer_tables`] || 1)
    return ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta'].filter(
      (nn, idx) => idx + 1 <= numOfTables && !state.locked_namespaces.includes(nn),
    )
  },
  // hands_solType: state => state.solType,
  hands_configure: state => state.configure,
  hands_instances: (state, getters, rootState, rootGetters) => {
    if (getters.globals_mobile) {
      return ['alpha']
    }
    const numOfTables = Number(rootGetters[`tra/alpha/fh_trainer_tables`] || 1)
    // if (mt === 1) {
    //   return ['alpha']
    // }
    // console.log(numOfTables)
    const res = ['alpha', 'beta', 'gamma', 'delta'].filter((_, idx) => idx <= numOfTables - 1)
    return res
  },
  hands_namespaces: (state, getters, rootState, rootGetters) => {
    const res = getters.hands_instances.map(inst => `tra/${inst}`)
    return res
  },
  hands_active_uids: (state, getters, rootState, rootGetters) => {
    const res = getters.hands_instances.map(inst => rootGetters[`tra/${inst}/trainer_hand_uid`])
    return res
  },
  trainer_timebank_running: (state, getters, rootState, rootGetters) => {
    const res = getters.hands_instances.some(
      inst => rootGetters[`tra/${inst}/trainer_timebank_timeout`],
    )
    return res
  },
}

const actions = {
  hands_handle_error(
    { state, getters, rootGetters, commit, dispatch },
    { namespace, result, handler },
  ) {
    // console.log({ namespace, result })
    dispatch(`${namespace}/gamestate_reset_next`)

    const errResponse = result?.error?.response
    const code = errResponse?.data?.code
    const status = errResponse?.status

    if (status === 400 && code === 'INVALID_SESSION') {
      commit(`session_set`, {
        key: 'session_error',
        value: {
          handler,
          result,
        },
      })
    } else {
      commit(
        `${namespace}/trainer_set`,
        {
          key: 'trainer_error',
          value: {
            handler,
            result,
          },
        },
        { root: true },
      )
    }
  },
  hands_start_session(
    { state, getters, rootGetters, commit, dispatch },
    { sessionSettings = null } = {},
  ) {
    const alpha = 'tra/alpha'
    dispatch(`drills_setCheck_selected_drill`)
    dispatch(`session_reset`)
    commit(`hands_set`, { key: 'configure', value: false })
    commit(`hands_set`, { key: 'locked_namespaces', value: [] })
    dispatch(`hands_set_active_namespace`, { namespace: alpha })

    commit('stats_set', { key: 'stats_session_result_visible', value: false })
    commit('panels_set', { key: 'panel_left', value: false })
    commit('panels_set', { key: 'panel_right', value: false })

    if (sessionSettings) {
      // session from history
      dispatch(`${alpha}/router_update_query`, {
        query: sessionSettings,
        push: false,
        replace: false,
        saveLocally: false,
      })
      dispatch('hands_stop', { configure: false })
    }

    dispatch('hands_copy_alpha', { namespaces: rootGetters.hands_namespaces })

    dispatch('hands_call_session')
  },
  hands_call_session(
    { state, getters, rootGetters, commit, dispatch },
    { repeatHand = false, playFromHere = false, settingsHand = null } = {},
  ) {
    const namespace = 'tra/alpha'
    let settings = rootGetters[`${namespace}/query_trainer`]
    settings = getTrainerClearQuery(settings)
    settings = sanitizeQuery(settings)
    const gameformat = rootGetters[`${namespace}/gameformat`]
    dispatch('api_practice_session', {
      namespace,
      settings,
      gameformat,
      repeatHand,
      playFromHere,
      settingsHand,
    })
  },
  hands_set_session({ state, getters, rootGetters, commit, dispatch }, result) {
    if (result?.response?.status !== 201) {
      dispatch(`hands_handle_error`, { handler: 'session', result, namespace: 'tra/alpha' })
    } else {
      const sessionId = result.response.data.id
      const { repeatHand } = result
      const { settingsHand } = result
      const { playFromHere } = result
      dispatch('session_start', sessionId)
      dispatch('hands_start', { repeatHand, playFromHere, settingsHand })
    }
  },

  hands_start(
    { state, commit, dispatch, getters, rootGetters },
    {
      namespaces = null,
      copyModule = false,
      toModuleParams = {},
      repeatHand = false,
      playFromHere = false,
      settingsHand = null,
    } = {},
  ) {
    dispatch(`hands_set_active_namespace`)

    namespaces = namespaces || rootGetters.hands_namespaces
    if (copyModule) {
      dispatch('hands_copy_alpha', { namespaces, toModuleParams })
    }

    namespaces.forEach(nn => {
      dispatch(`${nn}/trainer_hand_initialize`, { repeatHand, playFromHere, settingsHand })
    })
  },
  hands_copy_alpha(
    { state, commit, dispatch, getters, rootGetters },
    { namespaces, toModuleParams },
  ) {
    const alpha = 'tra/alpha'
    namespaces = namespaces || rootGetters.hands_namespaces

    const custom_solution = rootGetters.api_get('api_poker_custom_solution', alpha)
    const custom_solution_tree = rootGetters.api_get('api_poker_custom_solution_tree', alpha)

    namespaces.forEach(nn => {
      if (nn !== alpha) {
        dispatch('poker_copy_module', {
          from_namespace: alpha,
          to_namespace: nn,
          queryGroup: 'trainer',
          toModuleParams,
        })
        dispatch('poker_copy_module', {
          from_namespace: alpha,
          to_namespace: nn,
          queryGroup: 'router-to-gmf-selektor',
        })

        commit('api_update', {
          key: 'api_poker_custom_solution',
          result: custom_solution,
          replace: true,
          namespace: nn,
        })
        commit('api_update', {
          key: 'api_poker_custom_solution_tree',
          result: custom_solution_tree,
          replace: true,
          namespace: nn,
        })
      }
    })
  },
  hands_stop(
    { state, commit, dispatch, getters, rootGetters },
    { namespaces, configure = true } = {},
  ) {
    // let history_spots = unsetHsBot({ history_spots: rootGetters[`tra/alpha/history_spots`] })
    let history_spots = []
    let initialQuery = {}
    if (rootGetters[`tra/alpha/fh_start_spot`] === 'custom_spot') {
      // RF_TODO_11 - pass this to afunction returnig hspots and query
      const settings = JSON.parse(rootGetters[`tra/alpha/trainer_hand_settings`] || '{}')
      history_spots = settings.history_spots || []
      const hSpot = history_spots.find(i => i.is_active) || { id: 0 }

      if (history_spots.length) {
        history_spots = history_spots.filter(e => e.id <= hSpot?.id)
        history_spots = unsetHsSelectedAction({ history_spots, spot: hSpot })
      }

      const historyParams = getHistoryUrlParams({ history_spots, includeShowdown: false })
      initialQuery = {
        ...historyParams,
        history_spot: hSpot?.id,
        fh_hero: hSpot?.position || '',
        fh_opponent: '',
      }
    } else {
      const historyParams = getHistoryUrlParams({ history_spots: [], includeShowdown: false })
      initialQuery = {
        ...historyParams,
        history_spot: '0',
      }
    }

    namespaces = namespaces || rootGetters.hands_namespaces
    namespaces.forEach(nn => {
      dispatch(`poker_trainer_api_reset`, { namespace: nn })
      dispatch('session_unregister_hand', { hand_uid: rootGetters[`${nn}/trainer_hand_uid`] })

      commit(`${nn}/trainer_set`, { key: 'trainer_hand_settings', value: '' })
      dispatch(`${nn}/trainer_reset_hand`)
      dispatch(`${nn}/trainer_set_new_hand_state`)

      dispatch(`${nn}/gamestate_reset_next`)

      commit(`${nn}/gamestate_set`, {
        key: 'history_spots',
        value: history_spots,
      })

      const query = {
        board_tmp: '',
        hand_tmp: '',
        hand_op_tmp: '',
        fh_hero_tmp: '',
        fh_opponent_tmp: '',
        fh_action_tmp: '',
        fh_rel_position_tmp: '',
        ...initialQuery,
      }
      dispatch(`${nn}/router_update_query`, {
        query,
        push: false,
        replace: nn === 'tra/alpha',
        saveLocally: false,
      })
    })

    if (configure) {
      commit(`hands_set`, { key: 'locked_namespaces', value: [] })
      dispatch(`streak_reset`)
      dispatch(`session_reset`)
      commit(`stats_reset`)

      dispatch('hands_set_active_namespace', { namespace: 'tra/alpha' })
      commit(`hands_set`, { key: 'configure', value: configure })
    }
  },

  hands_new_hand({ state, commit, dispatch, getters, rootGetters }, { namespaces = null } = {}) {
    dispatch('session_start', null, { root: true })
    namespaces = namespaces || rootGetters.hands_namespaces
    namespaces.forEach(namespace => {
      dispatch(`${namespace}/trainer_new_hand`)
    })
  },
  hands_repeat_hand({ state, commit, dispatch, getters, rootGetters }, { namespaces = null } = {}) {
    dispatch('session_start', null, { root: true })
    namespaces = namespaces || rootGetters.hands_namespaces
    namespaces.forEach(namespace => {
      dispatch(`${namespace}/trainer_repeat_hand`)
    })
  },
  hands_set_active_namespace(
    { state, commit, dispatch, getters, rootGetters },
    { namespace = null } = {},
  ) {
    if (!namespace) {
      const remainingNamespaces = rootGetters.hands_namespaces.filter(
        nn => !state.locked_namespaces.includes(nn),
      )
      namespace = remainingNamespaces[0] || ''
    }

    if (!namespace) return
    if (state.active_namespace === namespace) return
    if (state.locked_namespaces.some(nn => nn === namespace)) return

    // bypass VueRouter cos its slow and we only need to update url
    let query = rootGetters[`${namespace}/query_query`]
    query.router_namespace = namespace
    query = omitBy(query, isEmpty)

    const path = '/practice/trainer/'
    const params = new URLSearchParams(query)
    // console.log(`${params}`)
    const url = `${window.location.origin}${path}?${params}`
    history.replaceState(null, '', url)

    state.active_namespace = namespace
  },
  hands_clear_timeouts({ state, commit, dispatch, getters, rootGetters }) {
    const namespaces = ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta']
    namespaces.forEach(nn => {
      dispatch(`${nn}/trainer_clear_timebank`)
      dispatch(`${nn}/trainer_auto_new_hand_stop`)
    })
  },

  hands_lock_namespaces(
    { state, commit, dispatch, getters, rootGetters },
    { namespaces = null } = {},
  ) {
    namespaces = namespaces || rootGetters.hands_namespaces
    commit(`hands_set`, { key: 'locked_namespaces', value: namespaces })
    setTimeout(() => {
      // action keydown can trigger next table - so wait all procceses are done
      dispatch('hands_set_active_namespace')
    }, 0)
  },
  hands_lock_namespace({ state, commit, dispatch, getters, rootGetters }, { namespace } = {}) {
    const namespaces = [...state.locked_namespaces, namespace]
    dispatch(`hands_lock_namespaces`, { namespaces })
  },
  hands_unlock_namespace({ state, commit, dispatch, getters, rootGetters }, { namespace } = {}) {
    const namespaces = state.locked_namespaces.filter(nn => nn !== namespace)
    dispatch(`hands_lock_namespaces`, { namespaces })
  },
}
const mutations = {
  hands_reset(state, initialState) {
    Object.assign(state, initialState)
  },
  hands_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
